import MIGRATOR_ABI from './migrator.json'

const MIGRATOR_ADDRESS = '0xc0f45249DD135fcA133A20355d5a96e353cfC1F9'

export { MIGRATOR_ADDRESS, MIGRATOR_ABI }
